import { render, staticRenderFns } from "./AdminCreateItemSmell.vue?vue&type=template&id=27f92713&scoped=true&"
import script from "./AdminCreateItemSmell.vue?vue&type=script&lang=js&"
export * from "./AdminCreateItemSmell.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateItemSmell.vue?vue&type=style&index=0&id=27f92713&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f92713",
  null
  
)

export default component.exports